export default "/static/explore/b946185d86a00c241a56a2bd371c89821aef0275/_next/static/images/header-image-disney-fan-c206dbfcb637297119ba65229ae124a9.png";